import { render } from "./ReplenComp.vue?vue&type=template&id=0f28f9b2&scoped=true"
import script from "./ReplenComp.vue?vue&type=script&lang=js"
export * from "./ReplenComp.vue?vue&type=script&lang=js"

import "./ReplenComp.vue?vue&type=style&index=0&id=0f28f9b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f28f9b2"]])

export default __exports__